import React from "react";
import UpdatePasswordForm from "../../../components/Form/UpdatePasswordForm/UpdatePasswordForm";
import UpdateProfileForm from "../../../components/Form/UpdateProfileForm/UpdateProfileForm";
import Sidebar from "../../../components/Sidebar/Sidebar";
import { Page } from "../../../components/Layout/Page";
import { PageSection } from "../../../components/Layout/PageSection";
import { SectionHeader } from "../../../components/SectionHeader/SectionHeader";

const AccountPage: React.FC = () => {
  return (
    <Sidebar
      content={() => {
        return (
          <Page title="Account">
            <PageSection
              header={() => (
                <SectionHeader
                  text="Profile"
                  subtext="View and edit your account profile"
                />
              )}
            >
              <UpdateProfileForm />
            </PageSection>

            <PageSection
              header={() => (
                <SectionHeader
                  text="Security"
                  subtext="Manage your account credentials"
                />
              )}
            >
              <UpdatePasswordForm />
            </PageSection>
          </Page>
        );
      }}
    />
  );
};

export default AccountPage;
